import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["badge", "content", "header", "icon", "theme", "timestamp"];
// @ts-expect-error untyped module
import { Small } from 'UIComponents/elements';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import PreviewHeader from 'automation-ui-canvas/components/test-flow/PreviewHeader';
import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PreviewCard = _ref => {
  let {
      badge,
      content,
      header,
      icon,
      theme,
      timestamp
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", Object.assign({}, rest, {
    children: [header && /*#__PURE__*/_jsx(PreviewHeader, {
      use: !theme || theme === 'default' ? 'heffalump' : theme,
      icon: /*#__PURE__*/_jsx(UIIcon, {
        name: icon,
        size: "small"
      }),
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        justify: "between",
        children: [header, badge]
      })
    }), /*#__PURE__*/_jsxs(View, {
      paddingInline: header ? '600' : '0',
      paddingBlock: header ? '500' : '0',
      children: [/*#__PURE__*/_jsx("div", {
        className: "m-bottom-2",
        children: content
      }), timestamp && /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
          value: timestamp,
          format: "lll z"
        })
      })]
    })]
  }));
};
export default PreviewCard;